import { render, staticRenderFns } from "./campaignGeneralInfoUpdate.vue?vue&type=template&id=1a099e0a&"
import script from "./campaignGeneralInfoUpdate.vue?vue&type=script&lang=js&"
export * from "./campaignGeneralInfoUpdate.vue?vue&type=script&lang=js&"
import style0 from "./campaignGeneralInfoUpdate.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports